import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "shape-holder" }
const _hoisted_2 = ["data-type"]

import { Addon, Graph } from '@antv/x6';
    import { Dnd } from '@antv/x6/lib/addon/dnd';
    
    import { onMounted, Ref, ref, watch } from 'vue';
    import { node_types } from '@/utils/antv-model';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'GraphModelerElementsBar',
  props: {
    graph: {}
  },
  setup(__props: any) {

    // https://github.com/antvis/X6/blob/master/sites/x6-sites-demos/packages/tutorial/basic/dnd/dnd/src/app.tsx

    const props = __props

    const dnd: Ref<Dnd | undefined> = ref();

    onMounted(() => {
        // https://github.com/antvis/X6/blob/master/sites/x6-sites-demos/packages/tutorial/basic/dnd/dnd/src/app.tsx
        // https://x6.antv.vision/en/docs/tutorial/basic/dnd

        // console.log(dnd.value);
    })

    watch(() => props.graph, (value: typeof props.graph) => {
        if (typeof value !== "undefined")
            init_dnd(value)

        // console.log("node-create", Node.create(node_types["notice"]))
    })

    const init_dnd = (graph: Graph) => {
        dnd.value = new Addon.Dnd({
            target: graph,
            scaled: false,
            animation: true,
            validateNode(droppingNode) {
                droppingNode.updateData({'is_stencil_node': undefined});
                return true;
            },
            
        })
    }
    
    const startDrag = (e: MouseEvent) => {
        if (typeof props.graph == "undefined")
            return false;

        /*
        const types = {
            'rect': {
                width: 100,
                height: 40,
                attrs: {
                    label: {
                        text: 'Rect',
                        fill: '#6a6c8a',
                    },
                    body: {
                        stroke: '#31d0c6',
                        strokeWidth: 2,
                    },
                },
            },
            'circle': {
                width: 100,
                height: 40,
                shape: 'html',
                html: () => {
                    const wrap = document.createElement('div')
                    wrap.style.width = '100%'
                    wrap.style.height = '100%'
                    wrap.style.display = 'flex'
                    wrap.style.alignItems = 'center'
                    wrap.style.justifyContent = 'center'
                    wrap.style.border = '2px solid rgb(49, 208, 198)'
                    wrap.style.background = '#fff'
                    wrap.style.borderRadius = '100%'
                    wrap.innerText = 'Circle'
                    return wrap
                },
            }
        };
        */

        const target = e.currentTarget
        const type = (target as HTMLElement).getAttribute('data-type')!

        if (!(type in node_types)) {
            return false
        }

        const node = props.graph.createNode(node_types[type as keyof node_types].antv_metadata);

        // node.label = type
        // node.setData({label: type})
        
        // (node as any).setLabel(type)
        // node.setAttrByPath('text/text', type)
        node.setData({label: type, is_stencil_node: true})
        
        dnd.value?.start(node, e)

    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(node_types), (node_type, node_type_name) => {
      return (_openBlock(), _createElementBlock("div", {
        key: node_type_name,
        class: _normalizeClass(`node node-${node_type_name}`),
        "data-type": node_type_name,
        onMousedown: _cache[0] || (_cache[0] = ($event: any) => (startDrag($event)))
      }, _toDisplayString(node_type_name), 43, _hoisted_2))
    }), 128))
  ]))
}
}

})